var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _polygon3, _path37, _polygon4, _path38, _polygon5, _path39, _path40, _polygon6, _path41, _path42, _path43, _path44, _circle2, _path45, _path46, _path47, _path48, _path49, _circle3, _path50, _circle4, _path51, _circle5, _path52, _circle6, _path53, _path54, _path55, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1003.67 546.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;}.cls-2{fill:#ffb6b6;}.cls-3{fill:#fb3640;}.cls-4{fill:#2f2e41;}.cls-5{fill:#e6e6e6;}.cls-6{fill:#fff;}.cls-7{fill:#fd6584;}.cls-8{fill:#ffb7b7;}.cls-9{fill:#a0616a;}.cls-10{fill:#3f3d56;}.cls-11{fill:#ccc;}.cls-12{fill:#483e37;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.32,556.27l16.12-5.11a54.72,54.72,0,0,0-.39-26.25c-6.48,14.4-25.48,17.93-36.3,29.42a32.78,32.78,0,0,0-8.4,27.18L199,593a55,55,0,0,0,40-22.77,52.73,52.73,0,0,0,6.23-11.78C238.34,557.77,231.32,556.27,231.32,556.27Z",
    transform: "translate(0 -49)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M802.54,556.27l-16.12-5.11a54.6,54.6,0,0,1,.39-26.25c6.48,14.4,25.48,17.93,36.3,29.42a32.82,32.82,0,0,1,8.4,27.18L834.9,593a55,55,0,0,1-40-22.77,53.11,53.11,0,0,1-6.22-11.78C795.52,557.77,802.54,556.27,802.54,556.27Z",
    transform: "translate(0 -49)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.09,535l12.15-11.77a54.63,54.63,0,0,0-12.05-23.32c.62,15.78-14.81,27.41-19.37,42.52a32.82,32.82,0,0,0,4.6,28.07l2.1,11.81a55,55,0,0,0,25.67-38.22,53.1,53.1,0,0,0,.31-13.33C221,533.21,214.09,535,214.09,535Z",
    transform: "translate(0 -49)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.57,316a9.17,9.17,0,0,1-10.3-7.86,9.6,9.6,0,0,1-.07-1.61l-58.55-59.41L194,235.69l52.41,62a9.21,9.21,0,0,1,.16,18.29Z",
    transform: "translate(0 -49)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.64,221.38s-4.15,2.48,2.76,10.06c5.53,6.06,29.66,35.21,39.29,41.3a7.18,7.18,0,0,0,2.82,8.35l14.81-18.48c-.85-5.29-4.42-5-6.42-4.38l-9.29-11.55-21.05-35.3-19.95,8.15Z",
    transform: "translate(0 -49)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "113.41 526.34 124.44 526.34 129.7 483.76 113.41 483.76 113.41 526.34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.8,567.78l17.64-1.06v7.56l16.76,11.58a4.72,4.72,0,0,1-2.68,8.6h-21L116.91,587l-1.41,7.47h-7.92Z",
    transform: "translate(0 -49)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "175.41 526.34 186.44 526.34 191.7 483.76 175.41 483.76 175.41 526.34"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.8,567.78l17.64-1.06v7.56l16.76,11.58a4.72,4.72,0,0,1-2.68,8.6h-21L178.91,587l-1.41,7.47h-7.92Z",
    transform: "translate(0 -49)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.64,538.62h.12l2.13-69.22a18.11,18.11,0,0,1,.23-17.11l.31-.55-.79-3.65a23.26,23.26,0,0,1,1.33-14l2-64.57c-7.08-45.86,26.64-75.76,26.64-75.76l-6.16-25.92,61-6-4.33,31.92L201.94,331c7.17,69.84,5.87,137.9-5.5,203.83l.31.16c1.11.38,1.59,1.93,1.07,3.45s-1.86,2.45-3,2.06l-26.67-.92c-1.12-.39-1.6-1.94-1.07-3.46s1.85-2.44,3-2.06l1.81.92L168,468.2l.43-12.2-.89-13.84-4.09-62.26L148,456.46l-15.81,82.93a2.91,2.91,0,0,1-2,5.07H108.64a2.92,2.92,0,0,1,0-5.84Z",
    transform: "translate(0 -49)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M693.59,330.71H316.32a47.9,47.9,0,0,1-47.85-47.84V120.7a47.89,47.89,0,0,1,47.71-47.84C374.77,56.64,437,48.62,501.12,49c61,.38,125.81,8.4,192.58,23.85a47.89,47.89,0,0,1,47.73,47.84V282.87A47.89,47.89,0,0,1,693.59,330.71ZM316.32,74.86a45.89,45.89,0,0,0-45.85,45.84V282.87a45.9,45.9,0,0,0,45.85,45.84H693.59a45.89,45.89,0,0,0,45.84-45.84V120.7a45.89,45.89,0,0,0-45.84-45.84l-.23,0c-138.16-32-261.4-32-376.78,0Z",
    transform: "translate(0 -49)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M309.66,288.39a1.14,1.14,0,0,1-1.13-1.13h0V116.31a1.13,1.13,0,0,1,2.26,0h0v171a1.13,1.13,0,0,1-1.13,1.13Z",
    transform: "translate(0 -49)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M408.66,288.39a1.14,1.14,0,0,1-1.13-1.13h0V116.31a1.13,1.13,0,0,1,2.26,0h0v171a1.13,1.13,0,0,1-1.13,1.13Z",
    transform: "translate(0 -49)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M507.66,288.39a1.14,1.14,0,0,1-1.13-1.13h0V116.31a1.13,1.13,0,0,1,2.26,0h0v171a1.13,1.13,0,0,1-1.13,1.13Z",
    transform: "translate(0 -49)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M606.66,288.39a1.14,1.14,0,0,1-1.13-1.13h0V116.31a1.13,1.13,0,1,1,2.26,0h0v171a1.13,1.13,0,0,1-1.13,1.13Z",
    transform: "translate(0 -49)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M300.84,141.78a1.14,1.14,0,0,1,1.14-1.13H707.92a1.14,1.14,0,1,1,0,2.27H302a1.14,1.14,0,0,1-1.14-1.13Z",
    transform: "translate(0 -49)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M300.84,267.78a1.14,1.14,0,0,1,1.14-1.13H707.92a1.14,1.14,0,1,1,0,2.27H302a1.14,1.14,0,0,1-1.14-1.13Z",
    transform: "translate(0 -49)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M300.84,204.78a1.14,1.14,0,0,1,1.14-1.13H707.92a1.14,1.14,0,1,1,0,2.27H302a1.14,1.14,0,0,1-1.14-1.13Z",
    transform: "translate(0 -49)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M702.5,288.39a1.14,1.14,0,0,0,1.14-1.13h0V116.31a1.14,1.14,0,0,0-2.27,0h0v171a1.14,1.14,0,0,0,1.13,1.13Z",
    transform: "translate(0 -49)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.41,197.11H342.9a6.52,6.52,0,0,1-6.45-5.6,145,145,0,0,1,0-39,6.51,6.51,0,0,1,6.34-5.6c9-4,18.63-4,28.72,0a6.43,6.43,0,0,1,4.9,2.36,6.56,6.56,0,0,1,1.36,5.49,87.69,87.69,0,0,0,0,34.54,6.56,6.56,0,0,1-1.36,5.49A6.42,6.42,0,0,1,371.41,197.11Z",
    transform: "translate(0 -49)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.43,161.76h-24a1.5,1.5,0,0,1,0-3h24a1.5,1.5,0,1,1,0,3Z",
    transform: "translate(0 -49)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.43,173.76h-24a1.5,1.5,0,0,1,0-3h24a1.5,1.5,0,1,1,0,3Z",
    transform: "translate(0 -49)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.43,185.76h-24a1.5,1.5,0,0,1,0-3h24a1.5,1.5,0,1,1,0,3Z",
    transform: "translate(0 -49)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M576.41,263.11H547.9a6.52,6.52,0,0,1-6.45-5.6,145,145,0,0,1,0-39,6.51,6.51,0,0,1,6.34-5.6c9-4,18.63-4,28.72,0a6.43,6.43,0,0,1,4.9,2.36,6.56,6.56,0,0,1,1.36,5.49,87.69,87.69,0,0,0,0,34.54,6.56,6.56,0,0,1-1.36,5.49A6.42,6.42,0,0,1,576.41,263.11Z",
    transform: "translate(0 -49)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M573.43,227.76h-24a1.5,1.5,0,0,1,0-3h24a1.5,1.5,0,0,1,0,3Z",
    transform: "translate(0 -49)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M573.43,239.76h-24a1.5,1.5,0,0,1,0-3h24a1.5,1.5,0,0,1,0,3Z",
    transform: "translate(0 -49)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M663.41,197.11H634.9a6.52,6.52,0,0,1-6.45-5.6,145,145,0,0,1,0-39,6.51,6.51,0,0,1,6.34-5.6c9-4,18.63-4,28.72,0a6.43,6.43,0,0,1,4.9,2.36,6.56,6.56,0,0,1,1.36,5.49,87.69,87.69,0,0,0,0,34.54,6.56,6.56,0,0,1-1.36,5.49A6.42,6.42,0,0,1,663.41,197.11Z",
    transform: "translate(0 -49)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M660.43,173.76h-24a1.5,1.5,0,0,1,0-3h24a1.5,1.5,0,0,1,0,3Z",
    transform: "translate(0 -49)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M660.43,185.76h-24a1.5,1.5,0,0,1,0-3h24a1.5,1.5,0,0,1,0,3Z",
    transform: "translate(0 -49)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.1,143.7c-5.68-8.69-14.94-15.53-25.26-16.1s-22.71,8.21-27.8,17.24c-9.32,16.54-9.44,35.5,3.39,47,1.74-.59,9-1.44,10.76-2l1.12-2L145.7,189c15.85,1.58,20.73-9.2,46.1-16C190.31,162.77,187.77,152.39,182.1,143.7Z",
    transform: "translate(0 -49)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 160.32,
    cy: 114.69,
    r: 20.96
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.55,202.64l-12-7.2-24-2.4-21.21,10.8.22,33L140,271l52.41,10.8,6.11-30.07s15.6-20.94-1.2-32.94Z",
    transform: "translate(0 -49)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.16,131.85a26.34,26.34,0,0,0-32.32,33c12.77,1,25.39-.18,35.34-9.21l.88-7.75,3.63,6.49,11-3.11A26.87,26.87,0,0,0,168.16,131.85Z",
    transform: "translate(0 -49)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.2,345.07a9.16,9.16,0,0,1-3-12.6,9.55,9.55,0,0,1,1-1.3l-7.74-83,19.86,1.53,1.36,81.15a9.21,9.21,0,0,1-11.45,14.26Z",
    transform: "translate(0 -49)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.09,204.17s-4.79-.7-4.23,9.53c.44,8.2-1.67,58.7,1.94,69.51a7.17,7.17,0,0,0-3.1,8.25l23.16-4.93c2.69-4.64,2.14-9.4.17-10.17l.12-14.82,5.12-48.85-19.71-8.08Z",
    transform: "translate(0 -49)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M245.45,352.75a6.56,6.56,0,0,1-1.36-5.49,87.69,87.69,0,0,0,0-34.54,6.56,6.56,0,0,1,1.36-5.49,6.43,6.43,0,0,1,4.9-2.36c10.09-4,19.75-4,28.72,0a6.51,6.51,0,0,1,6.34,5.6,145,145,0,0,1,0,39,6.52,6.52,0,0,1-6.45,5.6H250.45A6.4,6.4,0,0,1,245.45,352.75Z",
    transform: "translate(0 -49)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.43,319.76h24a1.5,1.5,0,1,0,0-3h-24a1.5,1.5,0,0,0,0,3Z",
    transform: "translate(0 -49)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.43,331.76h24a1.5,1.5,0,1,0,0-3h-24a1.5,1.5,0,0,0,0,3Z",
    transform: "translate(0 -49)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.43,343.76h24a1.5,1.5,0,1,0,0-3h-24a1.5,1.5,0,0,0,0,3Z",
    transform: "translate(0 -49)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "913.09 533.54 900.79 533.54 894.94 486.1 913.09 486.1 913.09 533.54"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M916.23,594.46H876.57V594A15.44,15.44,0,0,1,892,578.52h0l7.24-5.5,13.52,5.5h3.46Z",
    transform: "translate(0 -49)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "855.95 533.54 843.65 533.54 837.8 486.1 855.95 486.1 855.95 533.54"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M859.09,594.46H819.43V594a15.44,15.44,0,0,1,15.44-15.44h0l7.24-5.5,13.52,5.5h3.46Z",
    transform: "translate(0 -49)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "922.88 229.81 906.62 279.8 855.36 278.12 871.11 229.81 922.88 229.81"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M846.12,322.92l96.63,2.52-1.68,47.06s1.68,12.6-1.68,16-5,3.37-3.36,9.25-7.2,15.49-6.12,16.57,3.6,7,3.6,7l-8.4,47.89s-5.88,83.19-7.57,84.87-3.36,0-1.68,4.2,3.37,2.53,1.68,4.21a61.61,61.61,0,0,0-4.2,5H893s-1.53-8.41-1.53-9.25-1.68-5.88-1.68-6.72,1.48-2.32,1.48-2.32a28.43,28.43,0,0,0,1-5.24c0-1.68,5-66.38,5-66.38l-10.09-84-24.36,82.35s0,72.26-1.68,73.94-1.69.84-.85,4.2,4.21,2.52,1.69,5-3.37-1.68-2.53,2.53l.84,4.2-25.2.36s-3.37-7.09-1.68-9.61,1.58-1.83-.48-5.95-2.89-5-2-5.81.84-5.31.84-5.31l4.21-80.4s.84-84.87.84-87.39a8.46,8.46,0,0,0-.7-3.78v-3.42l3.22-12.13Z",
    transform: "translate(0 -49)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M854.94,200.66l29.41-10.93,48.74,3.36,11.29,5.27a19.53,19.53,0,0,1,10.88,21.56l-14.61,72.33,3.78,34.8s-61.34,46.29-109.23,32c0,0,.84-13.44,1.68-18.48s2.52-5,3.36-7.57,2.52,0,.84-5,13.44-40.33,13.44-40.33Z",
    transform: "translate(0 -49)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "901.43 158.05 925.4 143.56 917.54 129.39 892.08 129.39 881.99 141.61 901.43 158.05"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M909.68,326.16a9.4,9.4,0,0,0,9.91-8.83,10.08,10.08,0,0,0-.05-1.65l30-14.6-14.91-8.83-26.19,15.21a9.44,9.44,0,0,0,1.26,18.7Z",
    transform: "translate(0 -49)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M921.46,320.1l-5.23-19.16,28.47-37.71c-9.21-11.11-12.45-27.51-10.17-51.57a10.43,10.43,0,0,1,20.11-5.38c6.45,18.79,17.65,59.22,16.19,61.41-1.68,2.53-2.25,3.65.39,6.05,3.13,2.86,1.47,15,0,16.78C970,292.11,921.46,320.1,921.46,320.1Z",
    transform: "translate(0 -49)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M770.75,296.41A9.39,9.39,0,0,0,782.89,291a8.52,8.52,0,0,0,.45-1.59l33-4.69-11.48-13-29.59,6.45a9.43,9.43,0,0,0-4.54,18.18Z",
    transform: "translate(0 -49)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M784.91,293.65l5-19.22,41.5-23.38c3-19,4.88-25.19,18.83-44.92a10.44,10.44,0,0,1,20.13,5.36c-3.78,19.5-20.85,71.76-23,72.56C845.51,284.78,784.91,293.65,784.91,293.65Z",
    transform: "translate(0 -49)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 904.52,
    cy: 94.52,
    r: 26.05
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M876.93,124.62c.7-6.23,9.7-12.46,25.62-16.61s24.23,13.84,24.23,13.84c11.07,5.54,4.49,35,1,32.19l-.1-.08a20.65,20.65,0,0,1-8.24-14.07l-.79-7.17c-3.65,2.79-7.76,5.16-12.17,4.46l5.4-5.32-15.35,6.68,5.08-7-.24-.24a25.11,25.11,0,0,1-8,4.56c-3.36,1-7.38.44-9.69-2.19a7.22,7.22,0,0,1-1.37-2.47c-4.18,2.86-5,9-5,9S876.24,130.85,876.93,124.62Z",
    transform: "translate(0 -49)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M772.41,313.32H743.9a6.52,6.52,0,0,1-6.45-5.6,145,145,0,0,1,0-39,6.51,6.51,0,0,1,6.34-5.6c9-4,18.63-4,28.72,0a6.43,6.43,0,0,1,4.9,2.36,6.56,6.56,0,0,1,1.36,5.49,87.69,87.69,0,0,0,0,34.54,6.56,6.56,0,0,1-1.36,5.49A6.42,6.42,0,0,1,772.41,313.32Z",
    transform: "translate(0 -49)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M769.43,278h-24a1.5,1.5,0,0,1,0-3h24a1.5,1.5,0,0,1,0,3Z",
    transform: "translate(0 -49)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M769.43,290h-24a1.5,1.5,0,0,1,0-3h24a1.5,1.5,0,0,1,0,3Z",
    transform: "translate(0 -49)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M769.43,302h-24a1.5,1.5,0,0,1,0-3h24a1.5,1.5,0,0,1,0,3Z",
    transform: "translate(0 -49)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 650.43,
    cy: 53.84,
    r: 19
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M660.18,94.92a1.55,1.55,0,0,0-2.12,0,63.17,63.17,0,0,0-10.78,11l-2.3-4.46c-.89-1.72-3.48-.2-2.6,1.51l3.38,6.52a1.51,1.51,0,0,0,2.08.51,1.55,1.55,0,0,0,.51-.51A61.1,61.1,0,0,1,660.18,97,1.51,1.51,0,0,0,660.18,94.92Z",
    transform: "translate(0 -49)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 557.43,
    cy: 53.84,
    r: 19
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M567.18,94.92a1.55,1.55,0,0,0-2.12,0,63.17,63.17,0,0,0-10.78,11l-2.3-4.46c-.89-1.72-3.48-.2-2.6,1.51l3.38,6.52a1.51,1.51,0,0,0,2.08.51,1.55,1.55,0,0,0,.51-.51A61.1,61.1,0,0,1,567.18,97,1.51,1.51,0,0,0,567.18,94.92Z",
    transform: "translate(0 -49)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 361.43,
    cy: 51.84,
    r: 19
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M371.18,92.92a1.55,1.55,0,0,0-2.12,0,63.17,63.17,0,0,0-10.78,11L356,99.48c-.89-1.72-3.48-.2-2.6,1.51l3.38,6.52a1.51,1.51,0,0,0,2.08.51,1.55,1.55,0,0,0,.51-.51A61.1,61.1,0,0,1,371.18,95,1.51,1.51,0,0,0,371.18,92.92Z",
    transform: "translate(0 -49)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 134.43,
    cy: 86.84,
    r: 13
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M282.67,594.1a1.18,1.18,0,0,1-1.18,1.19H1.19a1.19,1.19,0,1,1,0-2.38H281.48a1.19,1.19,0,0,1,1.19,1.19Z",
    transform: "translate(0 -49)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1003.67,594.1a1.18,1.18,0,0,1-1.18,1.19H722.19a1.19,1.19,0,0,1,0-2.38h280.29a1.19,1.19,0,0,1,1.19,1.19Z",
    transform: "translate(0 -49)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.51,122.8c-2.25-.62-4.59.43-6.69,1.45l-7.47,3.63,15.52,1.36.57-1.07C134.23,126.67,132.76,123.43,130.51,122.8Z",
    transform: "translate(0 -49)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path915",
    className: "cls-3",
    d: "M508.77,361.81c-3.83,0-7.6,4.25-22.27,12.75-.58.33-1.12.62-1.67.95l22.94,28.6,23.85-29.33-.53-.31C516.39,366,512.58,361.81,508.77,361.81Zm-1,17.2a6.66,6.66,0,0,1,6.66,6.66h0a6.66,6.66,0,1,1-6.66-6.66Z",
    transform: "translate(0 -49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path913",
    className: "cls-3",
    d: "M536.17,377.32l-25.11,30.9,4.76,5.94L537,393.11,552,423.2l1.86,4.75c-.22-3.64-.49-8.41-.5-14.91-.06-31.76,6.16-23-17.25-35.72Z",
    transform: "translate(0 -49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path911",
    className: "cls-3",
    d: "M480.26,378.05c-22,11.84-16,3.94-16,35.15,0,3.39,0,6.27-.15,8.85l14.51-29.44L499.75,414l4.7-5.77Z",
    transform: "translate(0 -49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path907",
    className: "cls-12",
    d: "M480.08,401.36,468.43,425l-4.83,8.12c-.25,9.28,2.37,6.77,23,18.65,29.36,16.89,15.27,16.95,44.57-.07,16.78-9.73,21.65-9.88,22.72-14.59-2.2-3.83-4.39-7.69-6.47-11.59l-11.92-23.72L519.07,418.2l6.27,7.81-17.62,17.62-17.6-17.79,6.37-7.85Z",
    transform: "translate(0 -49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path905",
    className: "cls-3",
    d: "M507.74,412.31l-4.35,5.37,4.4,4.47,4.34-4.33Z",
    transform: "translate(0 -49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4587",
    className: "cls-3",
    d: "M500.13,421.68,497,425.5l10.71,10.82,10.67-10.67-3-3.77-7.59,7.55Z",
    transform: "translate(0 -49)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.e35f18c763fed6b79db25f1e6d0b883f.svg";
export { ForwardRef as ReactComponent };